import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { filterType } from "../../redux-store/types/api-types";
import { FilterSkeleton } from "../../components/dashboard/chart/CustomePieChart";
import { CustomDropdownBlueIcon } from "../../assets/SvgIcons";
import { useTheme } from "@mui/material";

type FilterProps = {
    options: Array<filterType>,
    defaultValue: number | string,
    IsLoading: boolean,
    setFilterValue?: React.Dispatch<React.SetStateAction<string | number>>
    filterFunction?: (value: string | number) => void
    ariaLabel?: string
}

export default function CustomDropdown({
    options,
    defaultValue,
    IsLoading,
    setFilterValue,
    filterFunction,
    ariaLabel = "Filter selector",
}: FilterProps) {
    const [value, setValue] = React.useState<string | number>(defaultValue);
    const theme = useTheme();

    // console.log('check', defaultValue, options)
    React.useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue)
        }
    }, [defaultValue])

    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value);
        setFilterValue && setFilterValue(event.target.value as string);
        filterFunction && filterFunction(event.target.value as string);
    };

    return (
        <>
            {
                IsLoading ? <FilterSkeleton /> :
                    <Box>
                        {/* <FormControl > */}
                        <Select
                            // labelId="demo-simple-select-label"
                            // id="demo-simple-select"
                            value={value as string}
                            defaultValue={defaultValue as string}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': ariaLabel }}
                            sx={{
                                color: theme.palette.primary[500],
                                fontWeight: 500,
                                fontSize: "16px",
                                fontFamily: `${theme.typography.fontFamily}`,
                                cursor: 'pointer',
                                border: "1px solid #fff",
                                padding: "7px 5px",
                                "& .MuiSelect-outlined": {
                                    padding: "0px 7px",
                                },

                                "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input": {
                                    paddingRight: "20px",
                                },

                                "&.Mui-focused": {
                                    backgroundColor: `${theme.palette.primary[50]}`,
                                    outline: `2px solid ${theme.palette.primary[500]}`,
                                    outlineOffset: '2px',
                                    border: "1px solid #1E90FF",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderWidth: "0",
                                        borderBottom: "1px dashed #A0AEC0",
                                    },
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderTop: 0,
                                    borderLeft: 0,
                                    borderRight: 0,
                                    marginBottom: 0,
                                    borderBottom: "1px dashed #A0AEC0",
                                    borderRadius: 0,
                                },
                            }}
                            IconComponent={CustomDropdownBlueIcon}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        padding: "0px 5px",
                                        borderRadius: "12px",
                                        // minWidth: "204px !important",

                                        "& .MuiMenuItem-root": {
                                            padding: "6px",
                                            borderRadius: "8px",
                                            fontWeight: 500,
                                            fontSize: "16px",
                                            fontFamily: `${theme.typography.fontFamily}`,
                                            color: "#1E90FF",
                                            my: 0.4,
                                            "&.Mui-selected": {
                                                backgroundColor: theme.palette.primary[500],
                                                color: theme.palette.common.white,
                                            },
                                            "&.Mui-focusVisible": {
                                                backgroundColor: 'transparent',
                                                color: theme.palette.primary[500],
                                                outline: `2px solid ${theme.palette.primary[500]}`,
                                                outlineOffset: '-2px',
                                            },
                                        },
                                        "& .MuiMenuItem-root:hover": {
                                            backgroundColor: "#E9F4FF",
                                            color: `${theme.palette.primary[900]}`,
                                        },
                                    },
                                },
                            }}
                        >
                            {options?.map((data: filterType, key: number) => (
                                <MenuItem key={key as number} value={data.value}>{data.label}</MenuItem>
                            ))}
                        </Select>
                        {/* </FormControl> */}
                    </Box>
            }
        </>

    );
}
